import { render, staticRenderFns } from "./BaseLazyLoadContent.vue?vue&type=template&id=2b1fc14c&scoped=true&"
import script from "./BaseLazyLoadContent.vue?vue&type=script&setup=true&lang=js&"
export * from "./BaseLazyLoadContent.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b1fc14c",
  null
  
)

export default component.exports